import React from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, Grid,
} from "@mui/material";
import { useIntl } from "react-intl";
import DraggablePaper from "./DraggablePaper";
import DetailField from "./DetailField";

/**
 * KPI（指標）詳細表示ダイアログ
 * Props:
 *   open        - boolean
 *   onClose     - () => void
 *   indicator   - { indicatorName, unit, measuringMethod, evaluationStandard, description }
 *   titleKey    - i18n key for dialog title (default: "kpi.detail.title")
 */
export default function KpiDetailDialog({ open, onClose, indicator, titleKey }) {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  if (!indicator) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperComponent={DraggablePaper}
    >
      <DialogTitle
        data-drag-handle
        sx={{ cursor: "move", userSelect: "none" }}
      >
        {t(titleKey || "kpi.detail.title")}
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid size={12}>
            <DetailField
              label={t("businessKpi.indicatorName")}
              value={indicator.indicatorName}
            />
          </Grid>
          <Grid size={12}>
            <DetailField
              label={t("businessKpi.unit")}
              value={indicator.unit}
            />
          </Grid>
          <Grid size={12}>
            <DetailField
              label={t("businessKpi.measuringMethod")}
              value={indicator.measuringMethod}
            />
          </Grid>
          <Grid size={12}>
            <DetailField
              label={t("businessKpi.evaluationStandard")}
              value={indicator.evaluationStandard}
            />
          </Grid>
          <Grid size={12}>
            <DetailField
              label={t("common.description")}
              value={indicator.description}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t("common.close")}</Button>
      </DialogActions>
    </Dialog>
  );
}
